const KEYS = Object.freeze({
  token: 'token',
  tenantid: 'tenantid',
  tenant: 'tenant',
  user: 'user',
});

function readJson(storage, key) {
  try {
    const raw = storage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getTenantId(tenant) {
  return String(
    tenant?.tenantid ||
    tenant?.tenantId ||
    tenant?.tenant_id ||
    tenant?.id_tenant ||
    tenant?.id ||
    ''
  ).trim();
}

export function readAuthSession() {
  return {
    token: sessionStorage.getItem(KEYS.token) || localStorage.getItem(KEYS.token) || '',
    tenantid: sessionStorage.getItem(KEYS.tenantid) || localStorage.getItem(KEYS.tenantid) || '',
    tenant: readJson(sessionStorage, KEYS.tenant) || readJson(localStorage, KEYS.tenant),
    user: readJson(sessionStorage, KEYS.user) || readJson(localStorage, KEYS.user),
  };
}

export function commitAuthSession({ token, user, tenant }) {
  const tenantid = getTenantId(tenant);
  if (!token || !tenantid) throw new Error('AUTH_SESSION_INCOMPLETE');

  const normalizedTenant = { ...(tenant || {}), tenantid };
  [sessionStorage, localStorage].forEach((storage) => {
    storage.setItem(KEYS.token, token);
    storage.setItem(KEYS.tenantid, tenantid);
    storage.setItem(KEYS.tenant, JSON.stringify(normalizedTenant));
    storage.setItem(KEYS.user, JSON.stringify(user || null));
  });
}

export function clearAuthSession() {
  [sessionStorage, localStorage].forEach((storage) => {
    ['token', 'tenantid', 'tenantId', 'tenant_id', 'tenant', 'user'].forEach((key) => storage.removeItem(key));
  });
}
